module.exports = __webpack_public_path__ + "static/img/a02.f3ef6cd2.jpg";